import UAParser from 'ua-parser-js';
import { IWindow } from '../Window';

export function getBrowser(window: IWindow) {
  const userAgent = window.navigator.userAgent;
  const parser = new UAParser(userAgent);

  return parser.getBrowser();
}
